var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_8138)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1168_8138",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.16288 32 0 24.8371 0 16C0 7.16288 7.16288 0 16 0C24.8371 0 32 7.16288 32 16C32 24.8371 24.8371 32 16 32Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1168_8138)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9976 15.9998L-6.63281 15.8603L-6.61233 15.0283L15.9976 15.9998Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9966 16.0002L-6.61719 15.1669L-6.58263 14.4731L15.9966 16.0002Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0009 15.9999L-6.58594 14.6124L-6.53474 13.9199L16.0009 15.9999Z",
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.999 16.0001L-6.54688 14.0584L-6.47904 13.3672L15.999 16.0001Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9987 16.0003L-6.49219 13.5055L-6.40771 12.8169L15.9987 16.0003Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0012 16.0001L-6.42188 12.9549L-6.32076 12.2676L16.0012 16.0001Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9974 16.0002L-6.34375 12.4047L-6.22599 11.7212L15.9974 16.0002Z",
    fill: "#F8FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9964 15.9998L-6.25 11.8577L-6.1156 11.1768L15.9964 15.9998Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9983 16.0002L-6.14062 11.3141L-5.98831 10.6357L15.9983 16.0002Z",
    fill: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9938 16.0002L-6.02344 10.7714L-5.85448 10.0981L15.9938 16.0002Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9988 16.0001L-5.88281 10.2324L-5.69849 9.56299L15.9988 16.0001Z",
    fill: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L-5.73438 9.69752L-5.53214 9.0332L16 16.0002Z",
    fill: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.995 16L-5.57812 9.16604L-5.35924 8.50684L15.995 16Z",
    fill: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0006 16.0002L-5.39844 8.63894L-5.1642 7.98486L16.0006 16.0002Z",
    fill: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16.0003L-5.21094 8.11545L-4.96134 7.46777L15.9999 16.0003Z",
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9956 16L-5.01562 7.59685L-4.75066 6.95557L15.9956 16Z",
    fill: "#EFF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.994 15.9998L-4.80469 7.08331L-4.52309 6.44971L15.994 15.9998Z",
    fill: "#EEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9953 16.0003L-4.57812 6.57691L-4.28117 5.94971L15.9953 16.0003Z",
    fill: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 16L-4.33594 6.0749L-4.02362 5.4541L16.0007 16Z",
    fill: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0011 15.9999L-4.08594 5.57815L-3.75826 4.96631L16.0011 15.9999Z",
    fill: "#EBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9965 16L-3.82812 5.08933L-3.48637 4.48389L15.9965 16Z",
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.996 16L-3.55469 4.60545L-3.19757 4.01025L15.996 16Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16.0002L-3.26562 4.12951L-2.89443 3.54199L15.9997 16.0002Z",
    fill: "#E8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 15.9998L-2.96875 3.65931L-2.58219 3.08203L15.9996 15.9998Z",
    fill: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9958 16L-2.66406 3.19741L-2.2647 2.63037L15.9958 16Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9961 15.9998L-2.34375 2.74412L-1.93031 2.18604L15.9961 15.9998Z",
    fill: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.994 16.0002L-2.01562 2.29784L-1.5881 1.75L15.994 16.0002Z",
    fill: "#E4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.996 16.0002L-1.67188 1.86005L-1.23155 1.32373L15.996 16.0002Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9942 15.9998L-1.32031 1.43087L-0.867193 0.904785L15.9942 15.9998Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16.0002L-0.953125 1.01017L-0.487205 0.495605L15.9992 16.0002Z",
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9939 16.0002L-0.585938 0.599231L-0.107218 0.0961914L15.9939 16.0002Z",
    fill: "#E0EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.994 16L-0.203125 0.197086L0.288395 -0.294434L15.994 16Z",
    fill: "#DFE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9982 16.0002L0.195312 -0.196876L0.697072 -0.674316L15.9982 16.0002Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9947 15.9999L0.59375 -0.579978L1.10831 -1.0459L15.9947 15.9999Z",
    fill: "#DDE8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9979 16.0002L1.00781 -0.952153L1.53389 -1.40527L15.9979 16.0002Z",
    fill: "#DCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9986 16L1.42969 -1.31456L1.96601 -1.75488L15.9986 16Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 15.9998L1.85938 -1.668L2.40722 -2.09424L15.9995 15.9998Z",
    fill: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 16.0002L2.29688 -2.00941L2.85496 -2.42285L15.9993 16.0002Z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9979 15.9999L2.74219 -2.3399L3.30923 -2.73926L15.9979 15.9999Z",
    fill: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9979 16.0002L3.19531 -2.65964L3.77259 -3.04492L15.9979 16.0002Z",
    fill: "#D7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9967 16.0002L3.65625 -2.96816L4.24377 -3.33936L15.9967 16.0002Z",
    fill: "#D6E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9957 15.9998L4.125 -3.26544L4.7202 -3.62256L15.9957 15.9998Z",
    fill: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9961 15.9999L4.60156 -3.55082L5.20572 -3.89258L15.9961 15.9999Z",
    fill: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9967 16L5.08594 -3.82466L5.69778 -4.15234L15.9967 16Z",
    fill: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 16.0001L5.57812 -4.08691L6.19893 -4.39795L15.9999 16.0001Z",
    fill: "#D2E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9954 16L6.07031 -4.33664L6.69751 -4.63232L15.9954 16Z",
    fill: "#D1E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0015 16.0001L6.57812 -4.57338L7.21301 -4.85498L16.0015 16.0001Z",
    fill: "#D0DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9946 16L7.07812 -4.7987L7.72068 -5.06494L15.9946 16Z",
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.997 16.0001L7.59375 -5.01114L8.24271 -5.26074L15.997 16.0001Z",
    fill: "#CEDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9942 15.9998L8.10938 -5.21107L8.76345 -5.44531L15.9942 15.9998Z",
    fill: "#CDDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9941 16.0001L8.63281 -5.39891L9.29201 -5.61523L15.9941 16.0001Z",
    fill: "#CCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.998 16.0002L9.16406 -5.57297L9.82838 -5.77393L15.998 16.0002Z",
    fill: "#CBDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.998 16.0003L9.69531 -5.73414L10.3648 -5.91846L15.998 16.0003Z",
    fill: "#CADBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9942 16.0003L10.2266 -5.88133L10.8998 -6.05029L15.9942 16.0003Z",
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9944 15.9999L10.7656 -6.01742L11.4427 -6.16846L15.9944 15.9999Z",
    fill: "#C8DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9986 15.9998L11.3125 -6.13904L11.9922 -6.27344L15.9986 15.9998Z",
    fill: "#C7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0015 16.0002L11.8594 -6.24619L12.5429 -6.36523L16.0015 16.0002Z",
    fill: "#C6D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.994 16.0002L12.3984 -6.34096L13.0858 -6.44336L15.994 16.0002Z",
    fill: "#C5D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9982 16.0002L12.9531 -6.42284L13.6418 -6.50732L15.9982 16.0002Z",
    fill: "#C4D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9947 16.0001L13.5 -6.49075L14.1912 -6.55859L15.9947 16.0001Z",
    fill: "#C3D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9964 16L14.0547 -6.54597L14.7472 -6.59717L15.9964 16Z",
    fill: "#C2D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9969 16L14.6094 -6.58684L15.3031 -6.62012L15.9969 16Z",
    fill: "#C1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9973 16L15.1641 -6.61373L15.8578 -6.63037L15.9973 16Z",
    fill: "#C0D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9965 15.9999L15.7188 -6.62793H16.4125L15.9965 15.9999Z",
    fill: "#BFD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L16.2778 -6.62793L16.9715 -6.61001L16 15.9999Z",
    fill: "#BED3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L16.8333 -6.61377L17.5258 -6.57921L16 16Z",
    fill: "#BDD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.3875 -6.58691L18.08 -6.53571L16 16Z",
    fill: "#BCD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.9418 -6.5459L18.633 -6.47806L16 16Z",
    fill: "#BBD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L18.4934 -6.49072L19.1834 -6.40624L16 16.0002Z",
    fill: "#BAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L19.0451 -6.42285L19.7325 -6.32173L16 16.0002Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L19.5942 -6.34131L20.279 -6.22355L16 15.9998Z",
    fill: "#B8CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L20.1421 -6.24658L20.823 -6.11218L16 15.9998Z",
    fill: "#B7CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L20.6861 -6.13867L21.3645 -5.98635L16 16.0002Z",
    fill: "#B6CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L21.2288 -6.01709L21.9021 -5.84813L16 16.0002Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0003L21.7677 -5.88135L22.4358 -5.69703L16 16.0003Z",
    fill: "#B4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.3027 -5.73438L22.967 -5.53214L16 16Z",
    fill: "#B3CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L22.8339 -5.57324L23.4931 -5.35436L16 15.9999Z",
    fill: "#B2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L23.3613 -5.39893L24.0154 -5.16469L16 16.0001Z",
    fill: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L23.8848 -5.21094L24.5325 -4.96134L16 15.9999Z",
    fill: "#B0C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.4019 -5.01123L25.0445 -4.74627L16 16Z",
    fill: "#AFC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L24.9152 -4.79883L25.5501 -4.51723L16 15.9999Z",
    fill: "#AEC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L25.4234 -4.57324L26.0506 -4.27628L16 16.0002Z",
    fill: "#ADC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L25.9251 -4.33643L26.5459 -4.02411L16 16.0002Z",
    fill: "#ACC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L26.4218 -4.08691L27.0336 -3.75923L16 16.0001Z",
    fill: "#ABC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L26.9107 -3.82471L27.5162 -3.48295L16 15.9999Z",
    fill: "#AAC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L27.3946 -3.55078L27.9898 -3.19366L16 15.9999Z",
    fill: "#A9C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L27.8707 -3.26514L28.457 -2.89394L16 16.0001Z",
    fill: "#A8C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L28.3405 -2.96826L28.9178 -2.5817L16 16.0001Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L28.8026 -2.65967L29.3696 -2.26031L16 16.0002Z",
    fill: "#A6C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L29.2557 -2.33984L29.8138 -1.9264L16 16Z",
    fill: "#A5C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L29.7024 -2.00977L30.249 -1.58225L16 15.9998Z",
    fill: "#A4C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L30.1402 -1.66797L30.6765 -1.22765L16 15.9999Z",
    fill: "#A3C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L30.569 -1.31445L31.095 -0.861333L16 16.0001Z",
    fill: "#A2C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L30.9901 -0.952148L31.5046 -0.486228L16 16.0002Z",
    fill: "#A1BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L31.401 -0.57959L31.904 -0.10087L16 16.0002Z",
    fill: "#A0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L31.8029 -0.197266L32.2944 0.294254L16 15.9999Z",
    fill: "#9FBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L32.1958 0.197266L32.6746 0.699026L16 16.0001Z",
    fill: "#9EBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L32.5798 0.599121L33.0458 1.11368L16 16.0001Z",
    fill: "#9DBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L32.9523 1.00977L33.4054 1.53585L16 15.9998Z",
    fill: "#9CBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L33.3146 1.43115L33.7549 1.96747L16 16.0001Z",
    fill: "#9BBBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L33.6678 1.85986L34.0941 2.4077L16 16Z",
    fill: "#9ABAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0003L34.0096 2.29785L34.423 2.85593L16 16.0003Z",
    fill: "#99BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L34.3398 2.74414L34.7392 3.31118L16 15.9998Z",
    fill: "#98B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L34.6598 3.19727L35.0451 3.77455L16 15.9998Z",
    fill: "#97B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L34.9683 3.65967L35.3395 4.24719L16 16.0001Z",
    fill: "#96B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L35.2653 4.12939L35.6224 4.72459L16 16.0001Z",
    fill: "#95B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.5507 4.60547L35.8925 5.20963L16 16Z",
    fill: "#94B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L35.8246 5.08936L36.151 5.7012L16 16.0001Z",
    fill: "#93B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L36.0858 5.57812L36.3981 6.19893L16 15.9999Z",
    fill: "#92B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L36.3366 6.07471L36.6323 6.70191L16 15.9998Z",
    fill: "#91B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.5734 6.57666L36.855 7.21154L16 16Z",
    fill: "#90B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.7987 7.0835L37.0637 7.72606L16 16Z",
    fill: "#8FB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L37.0112 7.59668L37.2608 8.24564L16 15.9999Z",
    fill: "#8EB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.2109 8.11523L37.4451 8.76931L16 16Z",
    fill: "#8DB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.3978 8.63867L37.6154 9.29787L16 16Z",
    fill: "#8CB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L37.5718 9.16602L37.7741 9.83034L16 15.9999Z",
    fill: "#8BB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.7331 9.69727L37.9187 10.3667L16 16Z",
    fill: "#8AB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L37.8816 10.2324L38.0506 10.9057L16 16.0001Z",
    fill: "#89AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L38.0173 10.771L38.1683 11.4481L16 15.9998Z",
    fill: "#88AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.1376 11.314L38.2733 11.9936L16 16Z",
    fill: "#87AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.2464 11.8579L38.3654 12.5414L16 16Z",
    fill: "#86ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L38.3411 12.4043L38.4435 13.0917L16 15.9998Z",
    fill: "#85ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0002L38.423 12.9551L38.5075 13.6437L16 16.0002Z",
    fill: "#84ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0001L38.4909 13.5054L38.5587 14.1966L16 16.0001Z",
    fill: "#83ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L38.5459 14.0581L38.5971 14.7506L16 15.9999Z",
    fill: "#82AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9998L38.5869 14.6123L38.6202 15.3061L16 15.9998Z",
    fill: "#81AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16.0003L38.6138 15.167L38.6304 15.8608L16 16.0003Z",
    fill: "#80A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15.9999L38.6266 15.7222V16.4159L16 15.9999Z",
    fill: "#7FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.6266 16.2778L38.6099 16.9715L16 16Z",
    fill: "#7EA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.6138 16.8333L38.5792 17.5258L16 16Z",
    fill: "#7DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.5869 17.3875L38.5357 18.08L16 16Z",
    fill: "#7CA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.5459 17.9418L38.4781 18.633L16 16Z",
    fill: "#7BA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.4909 18.4934L38.4064 19.1834L16 16Z",
    fill: "#7AA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.423 19.0451L38.3206 19.7325L16 16Z",
    fill: "#79A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.3411 19.5942L38.2234 20.279L16 16Z",
    fill: "#78A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.2464 20.1421L38.1107 20.823L16 16Z",
    fill: "#77A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.1376 20.6861L37.9866 21.3645L16 16Z",
    fill: "#76A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L38.0173 21.2288L37.8483 21.9021L16 16Z",
    fill: "#75A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.8816 21.7677L37.6973 22.4358L16 16Z",
    fill: "#74A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.7331 22.3027L37.5322 22.967L16 16Z",
    fill: "#73A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.5718 22.8339L37.3542 23.4931L16 16Z",
    fill: "#729FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.3978 23.3613L37.1648 24.0154L16 16Z",
    fill: "#719FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.2109 23.8848L36.9613 24.5325L16 16Z",
    fill: "#709EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L37.0112 24.4019L36.745 25.0445L16 16Z",
    fill: "#6F9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.7987 24.9152L36.5171 25.5501L16 16Z",
    fill: "#6E9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.5734 25.4234L36.2765 26.0506L16 16Z",
    fill: "#6D9CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.3366 25.9251L36.0243 26.5459L16 16Z",
    fill: "#6C9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L36.0858 26.4218L35.7594 27.0336L16 16Z",
    fill: "#6B9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.8246 26.9107L35.4829 27.5162L16 16Z",
    fill: "#6A9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.5507 27.3946L35.1936 27.9898L16 16Z",
    fill: "#6999FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L35.2653 27.8707L34.8941 28.457L16 16Z",
    fill: "#6899FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.9683 28.3405L34.5818 28.9178L16 16Z",
    fill: "#6798FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.6598 28.8026L34.2605 29.3696L16 16Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.3398 29.2557L33.9264 29.8138L16 16Z",
    fill: "#6597FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L34.0096 29.7024L33.5821 30.249L16 16Z",
    fill: "#6496FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L33.6678 30.1402L33.2275 30.6765L16 16Z",
    fill: "#6395FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L33.3146 30.569L32.8614 31.095L16 16Z",
    fill: "#6294FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.9523 30.9901L32.4864 31.5046L16 16Z",
    fill: "#6194FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.5798 31.401L32.1011 31.904L16 16Z",
    fill: "#6093FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L32.1958 31.8029L31.7056 32.2944L16 16Z",
    fill: "#5F92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L31.8029 32.1958L31.3011 32.6746L16 16Z",
    fill: "#5E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L31.401 32.5798L30.8864 33.0458L16 16Z",
    fill: "#5D91FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.9901 32.9523L30.464 33.4054L16 16Z",
    fill: "#5C90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.569 33.3146L30.0326 33.7549L16 16Z",
    fill: "#5B90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L30.1402 33.6678L29.5923 34.0941L16 16Z",
    fill: "#5A8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L29.7024 34.0096L29.1443 34.423L16 16Z",
    fill: "#598EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L29.2557 34.3398L28.6886 34.7392L16 16Z",
    fill: "#588EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L28.8026 34.6598L28.224 35.0451L16 16Z",
    fill: "#578DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L28.3405 34.9683L27.753 35.3395L16 16Z",
    fill: "#568CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L27.8707 35.2653L27.2755 35.6224L16 16Z",
    fill: "#558CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L27.3946 35.5507L26.7904 35.8925L16 16Z",
    fill: "#548BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L26.9107 35.8246L26.2989 36.151L16 16Z",
    fill: "#538AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L26.4218 36.0858L25.801 36.3981L16 16Z",
    fill: "#528AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L25.9251 36.3366L25.2979 36.6323L16 16Z",
    fill: "#5189FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L25.4234 36.5734L24.7885 36.855L16 16Z",
    fill: "#5088FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.9152 36.7987L24.2739 37.0637L16 16Z",
    fill: "#4F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L24.4019 37.0112L23.7542 37.2608L16 16Z",
    fill: "#4E87FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L23.8848 37.2109L23.2307 37.4451L16 16Z",
    fill: "#4D86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L23.3613 37.3978L22.7021 37.6154L16 16Z",
    fill: "#4C86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.8339 37.5718L22.1696 37.7741L16 16Z",
    fill: "#4B85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L22.3027 37.7331L21.6333 37.9187L16 16Z",
    fill: "#4A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L21.7677 37.8816L21.0931 38.0506L16 16Z",
    fill: "#4984FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L21.2288 38.0173L20.5517 38.1683L16 16Z",
    fill: "#4883FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L20.6861 38.1376L20.0051 38.2733L16 16Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L20.1421 38.2464L19.4586 38.3654L16 16Z",
    fill: "#4681FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L19.5942 38.3411L18.9082 38.4435L16 16Z",
    fill: "#4581FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L19.0451 38.423L18.3565 38.5075L16 16Z",
    fill: "#4480FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L18.4934 38.4909L17.8035 38.5587L16 16Z",
    fill: "#437FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.9418 38.5459L17.2493 38.5971L16 16Z",
    fill: "#427FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L17.3875 38.5869L16.6938 38.6202L16 16Z",
    fill: "#417EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16L16.8333 38.6138L16.1382 38.6304L16 16Z",
    fill: "#407DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9954 16L16.2732 38.6266H15.5781L15.9954 16Z",
    fill: "#3F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.995 16L15.7172 38.6266L15.0234 38.6099L15.995 16Z",
    fill: "#3E7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9958 16L15.1625 38.6138L14.4688 38.5792L15.9958 16Z",
    fill: "#3D7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9941 16L14.6065 38.5869L13.9141 38.5357L15.9941 16Z",
    fill: "#3C7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 16L14.0584 38.5459L13.3672 38.4781L16.0001 16Z",
    fill: "#3B7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9959 16L13.5011 38.4909L12.8125 38.4064L15.9959 16Z",
    fill: "#3A79FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9981 16L12.953 38.423L12.2656 38.3206L15.9981 16Z",
    fill: "#3979FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9978 16L12.4023 38.3411L11.7188 38.2234L15.9978 16Z",
    fill: "#3878FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9949 16L11.8528 38.2464L11.1719 38.1107L15.9949 16Z",
    fill: "#3777FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9973 16L11.3112 38.1376L10.6328 37.9866L15.9973 16Z",
    fill: "#3677FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9958 16L10.767 38.0173L10.0938 37.8483L15.9958 16Z",
    fill: "#3576FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L10.2319 37.8816L9.5625 37.6973L15.9996 16Z",
    fill: "#3475FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9983 16L9.69557 37.7331L9.03125 37.5322L15.9983 16Z",
    fill: "#3375FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0009 16L9.16701 37.5718L8.50781 37.3542L16.0009 16Z",
    fill: "#3274FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L8.63846 37.3978L7.98438 37.1648L15.9997 16Z",
    fill: "#3173FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0012 16L8.11643 37.2109L7.46875 36.9613L16.0012 16Z",
    fill: "#3073FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9976 16L7.5944 37.0112L6.95312 36.745L15.9976 16Z",
    fill: "#2F72FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9954 16L7.07891 36.7987L6.44531 36.5171L15.9954 16Z",
    fill: "#2E71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9959 16L6.57251 36.5734L5.94531 36.2765L15.9959 16Z",
    fill: "#2D71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.999 16L6.07392 36.3366L5.45312 36.0243L15.999 16Z",
    fill: "#2C70FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9945 16L5.57278 36.0858L4.96094 35.7594L15.9945 16Z",
    fill: "#2B6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0005 16L5.08982 35.8246L4.48438 35.4829L16.0005 16Z",
    fill: "#2A6EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9976 16L4.60301 35.5507L4.00781 35.1936L15.9976 16Z",
    fill: "#296EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9973 16L4.12658 35.2653L3.53906 34.8941L15.9973 16Z",
    fill: "#286DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9959 16L3.6554 34.9683L3.07812 34.5818L15.9959 16Z",
    fill: "#276CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9946 16L3.19204 34.6598L2.625 34.2605L15.9946 16Z",
    fill: "#266CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0013 16L2.74558 34.3398L2.1875 33.9264L16.0013 16Z",
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 16L2.29784 34.0096L1.75 33.5821L16.0002 16Z",
    fill: "#246AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9968 16L1.85663 33.6678L1.32031 33.2275L15.9968 16Z",
    fill: "#236AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0013 16L1.43233 33.3146L0.90625 32.8614L16.0013 16Z",
    fill: "#2269FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9968 16L1.00675 32.9523L0.492188 32.4864L15.9968 16Z",
    fill: "#2168FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9978 16L0.59679 32.5798L0.09375 32.1011L15.9978 16Z",
    fill: "#2068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9975 16L0.194645 32.1958L-0.296875 31.7056L15.9975 16Z",
    fill: "#1F67FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9949 16L-0.202247 31.8029L-0.679688 31.3011L15.9949 16Z",
    fill: "#1E66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9989 16L-0.580955 31.401L-1.04688 30.8864L15.9989 16Z",
    fill: "#1D66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 16L-0.95313 30.9901L-1.40625 30.464L15.9992 16Z",
    fill: "#1C65FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9971 16L-1.31749 30.569L-1.75781 30.0326L15.9971 16Z",
    fill: "#1B64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 16L-1.66751 30.1402L-2.09375 29.5923L16.0003 16Z",
    fill: "#1A64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0012 16L-2.00843 29.7024L-2.42188 29.1443L16.0012 16Z",
    fill: "#1963FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.997 16L-2.34283 29.2557L-2.74219 28.6886L15.997 16Z",
    fill: "#1862FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9982 16L-2.6616 28.8026L-3.04688 28.224L15.9982 16Z",
    fill: "#1762FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9958 16L-2.97255 28.3405L-3.34375 27.753L15.9958 16Z",
    fill: "#1661FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9974 16L-3.26788 27.8707L-3.625 27.2755L15.9974 16Z",
    fill: "#1560FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.994 16L-3.55668 27.3946L-3.89844 26.7904L15.994 16Z",
    fill: "#1460FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9961 16L-3.82857 26.9107L-4.15625 26.2989L15.9961 16Z",
    fill: "#135FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 16L-4.0874 26.4218L-4.39844 25.801L15.9996 16Z",
    fill: "#125EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9995 16L-4.33713 25.9251L-4.63281 25.2979L15.9995 16Z",
    fill: "#115EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9957 16L-4.57778 25.4234L-4.85938 24.7885L15.9957 16Z",
    fill: "#105DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9946 16L-4.80407 24.9152L-5.07031 24.2739L15.9946 16Z",
    fill: "#0F5CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9952 16L-5.01603 24.4019L-5.26562 23.7542L15.9952 16Z",
    fill: "#0E5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-5.21107 23.8848L-5.44531 23.2307L15.9998 16Z",
    fill: "#0D5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9982 16L-5.40087 23.3613L-5.61719 22.7021L15.9982 16Z",
    fill: "#0C5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0006 16L-5.57248 22.8339L-5.77344 22.1696L16.0006 16Z",
    fill: "#0B59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9968 16L-5.73756 22.3027L-5.92188 21.6333L15.9968 16Z",
    fill: "#0A59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9959 16L-5.88573 21.7677L-6.05469 21.0931L15.9959 16Z",
    fill: "#0958FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9964 16L-6.02084 21.2288L-6.17188 20.5517L15.9964 16Z",
    fill: "#0857FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 16L-6.13904 20.6861L-6.27344 20.0051L15.9998 16Z",
    fill: "#0757FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9983 16L-6.24815 20.1421L-6.36719 19.4586L15.9983 16Z",
    fill: "#0656FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9982 16L-6.34291 19.5942L-6.44531 18.9082L15.9982 16Z",
    fill: "#0555FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 16L-6.42333 19.0451L-6.50781 18.3565L15.9997 16Z",
    fill: "#0455FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9962 16L-6.49466 18.4934L-6.5625 17.8035L15.9962 16Z",
    fill: "#0354FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9956 16L-6.55036 17.9418L-6.60156 17.2493L15.9956 16Z",
    fill: "#0253FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9952 16L-6.59172 17.3875L-6.625 16.6938L15.9952 16Z",
    fill: "#0153FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9976 16L-6.61617 16.8333L-6.63281 16.1382L15.9976 16Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.995 15.9999L-6.63281 16.2777V15.7222L15.995 15.9999Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_8138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseActive);
export default __webpack_public_path__ + "static/media/baseActive.9998e2866ab6bb2c4db0e64bd5351cea.svg";
export { ForwardRef as ReactComponent };